import React, { useState } from "react"
import Modal from "../../../../components/Modal"
import { TAcreateRunpodWorkers } from "../../../../services/runpodAPI"

interface CreateModalProps {
  isOpen: boolean
  onClose: () => void
  onCreated: () => void
}

const CreateRunpodWorkerModal: React.FC<CreateModalProps> = ({ isOpen, onClose, onCreated }) => {
  const [form, setForm] = useState({
    gpu_count: 1,
    is_running: false,
    is_active: true,
    query: "",
    frame_strategy: "simple",
    interruptible: false,
  })

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const handleChange = (e: any) => {
    const { name, value, type, checked } = e.target

    setForm((prev) => {
      const updates: any = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }
      if (name === "interruptible" && checked) {
        updates.gpu_count = 1
      }
      if (name === "gpu_count" && prev.interruptible) {
        return prev
      }

      return updates
    })
  }

  const handleSubmit = async () => {
    try {
      setLoading(true)
      setError("")

      let parsedQuery = ""
      if (form.query.trim()) {
        try {
          parsedQuery = form.query
        } catch (err: unknown) {
          const message = err instanceof Error ? err.message : "Geçersiz JSON."
          setError("Query JSON formatında olmalı: " + message)
          setLoading(false)
          return
        }
      }

      const payload = {
        gpu_count: Number(form.gpu_count),
        is_running: false,
        is_active: true,
        query: parsedQuery,
        frame_strategy: form.frame_strategy,
        interruptible: form.interruptible,
      }

      await TAcreateRunpodWorkers(payload)
      onCreated()
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : "Oluşturma işlemi başarısız."
      setError(message)
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal
      classname="fixed inset-0 bg-black/50 flex justify-center items-center z-50"
      classname2="bg-white w-full md:w-1/3 rounded-xl p-6"
      onClick={onClose}
    >
      <h2 className="text-xl font-bold mb-4">Runpod Worker Oluştur</h2>

      {error && <div className="bg-red-100 text-red-700 p-2 rounded mb-3">{error}</div>}

      <div className="space-y-3">
        <div>
          <label className="font-medium text-sm">GPU Count</label>
          <input
            type="number"
            name="gpu_count"
            value={form.gpu_count}
            onChange={handleChange}
            disabled={form.interruptible}
            className="w-full p-2 border rounded disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
        </div>
        <div>
          <label className="font-medium text-sm">GPU Types</label>
          <p className="font-medium text-xs text-gray-600">NVIDIA RTX A4000</p>
          <p className="font-medium text-xs text-gray-600">NVIDIA RTX A4500</p>
        </div>
        <div>
          <label className="font-medium text-sm">Query</label>
          <textarea
            name="query"
            value={form.query}
            rows={3}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>

        <div>
          <label className="font-medium text-sm">Frame Strategy</label>
          <select
            name="frame_strategy"
            value={form.frame_strategy}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          >
            <option value="">Seçiniz</option>
            <option value="simple">simple</option>
            <option value="detailed">detailed</option>
          </select>
        </div>

        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            name="interruptible"
            id="interruptible"
            checked={form.interruptible}
            onChange={handleChange}
            className="w-4 h-4"
          />
          <label htmlFor="interruptible" className="font-medium text-sm cursor-pointer">
            Interruptible
          </label>
        </div>

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full py-2 bg-green-600 hover:bg-green-700 text-white rounded mt-4"
        >
          {loading ? "Oluşturuluyor..." : "Oluştur"}
        </button>
      </div>
    </Modal>
  )
}

export default CreateRunpodWorkerModal
